import { Main } from "./main/Main";

window.addEventListener('DOMContentLoaded', () => {
    
    const main = new Main();
    main.init();

});